import React from 'react'
import { TextField } from '@diversioteam/diversio-ds'

import { focusElement } from '../formBuilder.helpers'

import { HeaderProps } from './header.types'
import * as S from './header.styles'

export const Header = ({ title, description, onChangeTitle, onChangeDescription }: HeaderProps) => {
    return (
        <S.HeaderWrapper>
            <TextField
                name="title"
                inputProps={{ 'aria-label': 'Survey name' }}
                value={title}
                onChange={(e) => onChangeTitle(e.target.value)}
                onFocus={focusElement}
                placeholder="Survey Name"
                variant="standard"
                fullWidth
            />

            <TextField
                name="description"
                inputProps={{ 'aria-label': 'Description' }}
                defaultValue={description}
                onBlur={(e) => onChangeDescription(e.target.value)}
                onFocus={focusElement}
                placeholder="Enter a short description to help participants understand the survey"
                variant="standard"
                fullWidth
                multiline
            />
        </S.HeaderWrapper>
    )
}
